import { render, staticRenderFns } from "./UploadUpdateStatusForm.vue?vue&type=template&id=16c39355&scoped=true"
import script from "./UploadUpdateStatusForm.vue?vue&type=script&lang=js"
export * from "./UploadUpdateStatusForm.vue?vue&type=script&lang=js"
import style0 from "./UploadUpdateStatusForm.vue?vue&type=style&index=0&id=16c39355&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c39355",
  null
  
)

export default component.exports